import type { BattleRound } from "@loot-os/api-contract";
import { useTerminology } from "../../lib/terminology.js";

export interface RoundBox {
  name: string;
  imageUrl: string;
}

/** The battle's boxes in round order, as small tiles; the current round highlighted. */
export function BattleRoundsStrip({
  rounds,
  boxes,
  currentRound = -1,
  max = 8,
}: {
  rounds: readonly BattleRound[];
  boxes: ReadonlyMap<string, RoundBox>;
  currentRound?: number;
  max?: number;
}) {
  const terms = useTerminology();
  const shown = rounds.slice(0, max);
  const rest = rounds.length - shown.length;
  return (
    <div className="flex items-center gap-1">
      {shown.map((round) => {
        const box = boxes.get(round.boxId);
        const active = round.roundIndex === currentRound;
        return (
          <div
            key={round.roundIndex}
            title={`Round ${round.roundIndex + 1}: ${box?.name ?? terms.box.singular}`}
            className={`size-8 shrink-0 overflow-hidden rounded-md border bg-muted ${
              active ? "border-primary ring-2 ring-primary/40" : "border-border"
            }`}
          >
            {box?.imageUrl ? (
              <img src={box.imageUrl} alt="" className="size-full object-cover" />
            ) : null}
          </div>
        );
      })}
      {rest > 0 ? <span className="text-xs text-muted-foreground">+{rest}</span> : null}
    </div>
  );
}
